import React from 'react';
import { Link } from 'react-router-dom';
import { clientContent } from '../../client/content';
import styles from './Footer.module.scss';

export const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={`container ${styles.footerContainer}`}>
        <div className={styles.footerTop}>
          <div className={styles.footerBrand}>
            <span className={styles.brandTitle}>{clientContent.businessName}</span>
            <p className={styles.brandTagline}>{clientContent.tagline}</p>
          </div>

          <div className={styles.footerNavGroup}>
            <h3 className={styles.groupTitle}>Navigation</h3>
            <ul className={styles.footerNavList}>
              {clientContent.navLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className={styles.footerLink}>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className={styles.footerContactGroup}>
            <h3 className={styles.groupTitle}>Get in Touch</h3>
            <p className={styles.contactText}>
              Ready for a professional website without the hassle?
            </p>
            <a href={`mailto:${clientContent.contactEmail}`} className={styles.emailLink}>
              {clientContent.contactEmail}
            </a>
          </div>
        </div>

        <div className={styles.footerBottom}>
          <p className={styles.copyright}>
            &copy; {currentYear} {clientContent.businessName}. All rights reserved.
          </p>
          <p className={styles.subtext}>
            Professional websites for small businesses, without the hassle.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
